import { getKeyJson, removeKey } from '../utils/localStorage';
import { getIam, request } from '../utils/request';
import { isNN } from '../utils/tools';

/** 登录完获取用户第一个登录的菜单，里面会有sid等 */
export function getUserFirstMenu(params:any) {
  const iam = getIam();
  let gid:any;
  let temObj = getKeyJson('act6');
  if(isNN(temObj)){
    gid = temObj['groupid'];
    if(isNN(gid)){
      removeKey('act6');
    }else{
      gid = 0;
    }
  }else{
    gid = 0;
  }

  //如果是切换sid这种，去掉上下文及keys
  //如果是target _blank这种方式，不会调用这个api
  //登录成功后，会自动记住最后一个
  if(gid !== 0){
    delete params['ctxt'];
  }
  // TODO 暂时都不带keys 去除缓存 251110
  delete params['keys'];

  return request.post({
    url: `${iam}upms/menusps/getmenu/${gid}`,
    data: params
  });
}

export function getPublicMenus(params:any) {
  const iam = getIam();
  //const { iam } = useUserStore();
  return request.post({
    //对于对方局域网部署的场景，可以在这里加iam地址
    //这样相当于界面直接看见。也可以不加，这样就相当于直接取自己的iam路径
    //此时就要配置nginx，进行iam的转发。这样的优点是用户无体验，都是代理后台获取的
    url: `${iam}upms/menusps/pubmenus`,
    data: params
  });
}

export function getPassMenus(params:any) {
  const iam = getIam();
  return request.post({
    //对于对方局域网部署的场景，可以在这里加iam地址
    //这样相当于界面直接看见。也可以不加，这样就相当于直接取自己的iam路径
    //此时就要配置nginx，进行iam的转发。这样的优点是用户无体验，都是代理后台获取的
    url: `${iam}upms/menusps/passmenu`,
    data: params
  });
}

/** 获取菜单之后获取配置 */
export function getServiceConfig(ctxt:string,orgid?:string) {
  return request.post({
    url: `/${ctxt}/config`,
    data: {orgid}
  });
}
